import { Box } from "@mui/system";

import { Button, Typography } from "@mui/joy";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import { heightWithToolbar } from "../global";
import { ProjectsDatagrid } from "../hooks/projectsDatagrid/projectsDatagrid";
import { setFormOpen } from "../reducers/rhapsody";
import { usePro } from "../hooks/usePro/usePro";
import { proEnabled } from "../constants";

export default function Projects() {
  const param = useParams();
  const pro = usePro();
  const dispatch = useDispatch();

  if (param.projectID) return <Outlet />;

  return (
    <>
      <Box
        sx={{
          p: 2,
          display: "flex",
          gap: 2,
          flexDirection: "column",
          justifyContent: "stretch",
          margin: "auto",
          maxWidth: 1600,
          width: "100vw",
          position: "relative",
          flex: 1,
          height: heightWithToolbar,
        }}
      >
        <Helmet>
          <title>Rhapsody | Projects</title>
        </Helmet>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography level="h6">Projects</Typography>
          {proEnabled ? (
            <Button
              onClick={() =>
                dispatch(setFormOpen({ isOpen: true, formID: "project" }))
              }
              size="sm"
              color="info"
            >
              + New Project
            </Button>
          ) : (
            []
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            height: 0,
            minHeight: "auto",
          }}
        >
          <ProjectsDatagrid />
        </Box>
      </Box>
    </>
  );
}
